/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

const CallbackPage = lazy(() =>
  import("@krea/shared/features/callback-page").then((mod) => ({
    default: mod.CallbackPage,
  })),
);

const App = lazy(() => import("./App"));

export const router = createBrowserRouter([
  {
    path: "callback-page/:callbackPageId",
    element: <CallbackPage />, // For oauth callback handling
  },
  { path: "*", element: <App /> },
]);
